<div class="main">
    <div *ngIf="currentURL == '/login/payment'" class="iconContainer">
        <i class="fa fa-arrow-left" (click)="backIconClick()" style="cursor: pointer;"></i>
    </div>
    <div class="textContainer" *ngIf="!queryParams.isDisable && currentURL !== '/login/payment'">{{heading}}</div>

    <!-- <div style="margin-left: auto; margin-right:20px; display:flex; align-items:center;">
        <div *ngIf="loginStatus" (click)="showAvatarDropdown = !showAvatarDropdown"
            class="nav-item p-2 userIconContainer">
            <i class="fa fa-user" style="color: rgb(231,236,237); font-size:18px" aria-hidden="true"></i>

            <div *ngIf="showAvatarDropdown" class="avatarDropdown">
                <div (click)="redirectToDetailRegister()" style="display: flex; align-items:center;">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
                        <path
                            d="M320 566v-60h320v60H320Zm0-160v-60h320v60H320ZM220 666h320q26.43 0 49.215 12Q612 690 628 710l112 146V236H220v430Zm0 250h490L581 747q-7.565-9.882-18.283-15.441Q552 726 540 726H220v190Zm520 60H220q-24 0-42-18t-18-42V236q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18Zm-520-60V236v680Zm0-190v-60 60Z"
                            fill="#ED1556" />
                    </svg>
                    <span style="margin-left:5px;">
                        Profile
                    </span>
                </div>

                <div (click)="logoutClick()" style="display: flex; align-items:center; margin-top:5px;">

                    <svg id="Group_16557" data-name="Group 16557" xmlns="http://www.w3.org/2000/svg" width="20"
                        height="20" viewBox="0 0 24 24">
                        <path id="Path_6204" data-name="Path 6204" d="M0,0H24V24H0Z" fill="none" />
                        <path id="Path_6205" data-name="Path 6205"
                            d="M4,18H6v2H18V4H6V6H4V3A1,1,0,0,1,5,2H19a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1Zm2-7h7v2H6v3L1,12,6,8Z"
                            fill="#ED1556" />
                    </svg>
                    <span style="margin-left:5px;">
                        Logout
                    </span>

                </div>
            </div>
        </div>
        <div *ngIf="loginStatus" (click)="showAvatarDropdown = !showAvatarDropdown" class="nav-item p-2">
            <div class="nav-link active" style="font-weight: 600; cursor:pointer;">{{facilityName}}</div>
        </div>
    </div> -->

    <div class="profileContainer" *ngIf="loginStatus" (click)="showAvatarDropdown = !showAvatarDropdown">
        <div class="nav-item p-2 userIconContainer">
          <i class="fa fa-user" style="color: rgb(231,236,237); font-size:18px" aria-hidden="true"></i>
        </div>
        <div style="margin-left: 10px; font-weight:600; cursor:pointer;">{{facilityName}}</div>
  
        <i *ngIf="showAvatarDropdown" class="fa fa-caret-up" style="font-size: 20px; cursor:pointer; margin-left: 10px;" aria-hidden="true"></i>
        <i *ngIf="!showAvatarDropdown" class="fa fa-caret-down" style="font-size: 20px; cursor:pointer; margin-left: 10px;" aria-hidden="true"></i>
  
  
  
        <div *ngIf="showAvatarDropdown" class="headerDropdown shadow">
  
          <div (click)="redirectToDetailRegister()" class="profileText">
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
              <path
                d="M320 566v-60h320v60H320Zm0-160v-60h320v60H320ZM220 666h320q26.43 0 49.215 12Q612 690 628 710l112 146V236H220v430Zm0 250h490L581 747q-7.565-9.882-18.283-15.441Q552 726 540 726H220v190Zm520 60H220q-24 0-42-18t-18-42V236q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18Zm-520-60V236v680Zm0-190v-60 60Z"
                fill="gray" />
              <!-- fill="#ED1556" -->
            </svg>
            <span style="margin-left:10px;">
              Profile
            </span>
          </div>
  
          <div (click)="logoutClick()" class="logoutText">
  
            <svg id="Group_16557" data-name="Group 16557" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
              viewBox="0 0 24 24">
              <path id="Path_6204" data-name="Path 6204" d="M0,0H24V24H0Z" fill="none" />
              <path id="Path_6205" data-name="Path 6205"
                d="M4,18H6v2H18V4H6V6H4V3A1,1,0,0,1,5,2H19a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1Zm2-7h7v2H6v3L1,12,6,8Z"
                fill="gray" />
            </svg>
            <span style="margin-left:10px;">
              Logout
            </span>
  
          </div>
        </div>
  

    <div *ngIf="!loginStatus" class="loginContainer" (click)="loginClick()">
        LOGIN
    </div>
    <!-- <div *ngIf="loginStatus" class="loginContainer" (click)="logoutClick()">
        LOGOUT
    </div> -->
</div>